import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Gates admin routes. Only `admin` and `pharmacist` roles allowed.
 * Pharmacists can be further restricted at the page level.
 */
const AdminAuthGuard = ({ children, requireAdmin = false }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="grid min-h-screen place-items-center bg-slate-50">
                <div className="h-10 w-10 animate-spin rounded-full border-2 border-brand-200 border-t-brand-700" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    if (!["admin", "pharmacist"].includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return children;
};

export default AdminAuthGuard;
